import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoReintentoFuncionalidadControl } from '../_models/flujo-venta-paso-reintento-funcionalidad-control';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoReintentoFuncionalidadControlService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVPReintentosFuncionalidadesControles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControl[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControl[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControl ) );
  }

  listadoPorIdFlujoVentaPaso( idFlujoVentaPaso: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVenta/' + idFlujoVentaPaso ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControl[] ) );
  }

  crear( regCrear: FlujoVentaPasoReintentoFuncionalidadControl ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControl ) );
  }

  actualizar( regActualizar: FlujoVentaPasoReintentoFuncionalidadControl ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoReintentoFuncionalidadControl ) );
  }
}
